//Question Data

export const questionsBank = {
  "ISO-9001 module-1": [
    {
      question: "What is the primary objective of ISO 9001?",
      options: [
        "To ensure environmental compliance",
        "To improve financial performance",
        "To ensure consistent quality in products and services",
        "To manage occupational health and safety",
      ],
      // correctAnswer: "To ensure consistent quality in products and services",
    },
    {
      question: "What does PDCA stand for in ISO 9001?",
      options: [
        "Plan, Do, Control, Act",
        "Plan, Develop, Check, Act",
        "Prepare, Design, Control, Adjust",
        "Plan, Do, Check, Act",
      ],
      // correctAnswer: "Plan, Do, Check, Act",
    },
    {
      question: "Which clause of ISO 9001 focuses on Leadership?",
      options: ["Clause 4", "Clause 5", "Clause 6", "Clause 7"],
      // correctAnswer: "Clause 5",
    },
    {
      question: "Which of the following is NOT a core principle of ISO 9001?",
      options: [
        "Customer focus",
        "Process approach",
        "Financial control",
        "Improvement",
      ],
      // correctAnswer: "Financial control",
    },
    {
      question: "What is a nonconformity according to ISO 9001?",
      options: [
        "A deviation from specified requirements",
        "An opportunity for improvement",
        "A financial discrepancy",
        "A successful audit outcome",
      ],
      // correctAnswer: "A deviation from specified requirements",
    },
    {
      question:
        "Who is responsible for ensuring resources are available for the Quality Management System (QMS)?",
      options: [
        "Middle management",
        "Quality department",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management",
    },
    {
      question:
        "Which document outlines the scope of an organization's Quality Management System?",
      options: [
        "Quality Manual",
        "Financial Report",
        "Environmental Policy",
        "Employee Handbook",
      ],
      // correctAnswer: "Quality Manual",
    },
    {
      question: "In ISO 9001, what is meant by context of the organization?",
      options: [
        "The internal and external factors impacting the organization",
        "The company's financial status",
        "The hierarchical structure of the organization",
        "The geographic location of the company",
      ],
      // correctAnswer:
      //   "The internal and external factors impacting the organization",
    },
    {
      question: "What role do internal audits play in ISO 9001?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the QMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer:
      // "They help ensure the QMS is effectively implemented and maintained",
    },
    {
      question:
        "How often should the management review the Quality Management System?",
      options: ["Monthly", "Quarterly", "Annually", "As needed"],
      // correctAnswer: "Annually",
    },
  ],
  "ISO-14001 module-1": [
    {
      question: "What is the primary focus of ISO 14001?",
      options: [
        " Quality Management",
        "Environmental Management",
        "Information Security",
        "Occupational Health and Safety",
      ],
      // correctAnswer: "Environmental management",
    },
    {
      question: "Which clause of ISO 14001 deals with Environmental Aspects?",
      options: ["Clause 4.1", "Clause 6.1.2", "Clause 7.5", " Clause 8.1"],
      // correctAnswer: "Clause 6.1.2",
    },
    {
      question: "What does EMS stand for in the context of ISO 14001?",
      options: [
        " Environmental Management Standard",
        " Energy Management System",
        "Environmental Monitoring System",
        "Environmental Management System",
      ],
      // correctAnswer: "Environmental Management System",
    },
    {
      question: "Which of the following is NOT a core principle of ISO 14001?",
      options: [
        " Environmental performance improvement",
        " Compliance with legal requirements",
        " Financial performance improvement",
        "Pollution prevention",
      ],
      // correctAnswer: " Financial performance improvement",
    },
    {
      question: "What is an environmental aspect according to ISO 14001?",
      options: [
        "An element of an organization's activities that can interact with the environment",
        "A financial asset of the organization",
        "A part of the organization's marketing strategy",
        "A product specification",
      ],
      // correctAnswer:
      //   "An element of an organization's activities that can interact with the environment",
    },
    {
      question:
        "Who is responsible for the implementation of an EMS according to ISO 14001?",
      options: [
        "Middle management",
        "The quality department",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management",
    },
    {
      question:
        "What is the purpose of internal audits according to ISO 14001?",
      options: [
        " To improve financial performance",
        "To assess compliance with the environmental management system",
        "To develop new products",
        " To increase market share",
      ],
      // correctAnswer:
      //   "To assess compliance with the environmental management system",
    },
    {
      question: "Which document outlines the scope of an organization's EMS?",
      options: [
        " Quality Manual",
        "Environmental Policy",
        "Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Environmental Policy",
    },
    {
      question:
        "What is the significance of an environmental policy according to ISO 14001?",
      options: [
        " It demonstrates the organization's commitment to environmental management",
        "It outlines the financial strategies of the organization",
        "It specifies the marketing strategies of the organization",
        "It details the human resource policies",
      ],
      // correctAnswer:
      //   "It demonstrates the organization's commitment to environmental management",
    },
    {
      question:
        "How often should the effectiveness of the EMS be reviewed according to ISO 14001?",
      options: ["Daily", "Monthly", "Annually", "As needed"],
      correctAnswer: "Annually",
    },
  ],
  "ISO-45001 module-1": [
    {
      question: "What is the primary focus of ISO 45001?",
      options: [
        "Quality Management",
        "Environmental Management",
        "Occupational Health and Safety Management",
        "Information Security Management",
      ],
      // correctAnswer: "Occupational Health and Safety Management",
    },
    {
      question:
        "Which clause of ISO 45001 deals with Leadership and Worker Participation?",
      options: ["Clause 4", "Clause 5", "Clause 6", " Clause 7"],
      // correctAnswer: "Clause 5",
    },
    {
      question: "What does OHSMS stand for in the context of ISO 45001?",
      options: [
        "Occupational Health and Safety Management System",
        " Occupational Health and Safety Monitoring Standard",
        "Organizational Health and Safety Management Scheme",
        "Occupational Hazard Safety Management System",
      ],
      // correctAnswer: " Occupational Health and Safety Management System",
    },
    {
      question: "Which of the following is NOT a core component of ISO 45001?",
      options: [
        "Risk Assessment",
        "Financial Auditing",
        "Worker Participation",
        "Incident Investigation",
      ],
      // correctAnswer: "Financial Auditing"
    },
    {
      question:
        "What is the purpose of a hazard identification process in ISO 45001?",
      options: [
        "To evaluate financial performance",
        "To identify and assess workplace hazards",
        "To improve employee satisfaction",
        "To increase market share",
      ],
      // correctAnswer: "To identify and assess workplace hazards"
    },
    {
      question:
        "Who is responsible for ensuring the OHSMS is effectively implemented and maintained according to ISO 45001?",
      options: [
        "Middle management",
        "Health and safety department",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management"
    },
    {
      question: "What is a risk according to ISO 45001?",
      options: [
        "Any condition that ensures employee safety",
        "Any source of potential harm or damage",
        "Any financial transaction error",
        "Any planned marketing strategy",
      ],
      // correctAnswer: 'Any source of potential harm or damage'
    },
    {
      question: "Which document outlines the scope of an organization's OHSMS?",
      options: [
        "Quality Manual",
        "Occupational Health and Safety Policy",
        "Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Occupational Health and Safety Policy"
    },
    {
      question: "What role do internal audits play in ISO 45001?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the OHSMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer: "They help ensure the OHSMS is effectively implemented and maintained"
    },
    {
      question:
        "How often should the effectiveness of the OHSMS be reviewed according to ISO 45001?",
      options: ["Daily", "Monthly", "Annually", "As Needed"],
      // correctAnswer: "Annually"
    },
  ],
  "ISO-22000 module-1": [
    {
      question: "What is the primary focus of ISO 22000?",
      options: [
        "Environmental Management",
        "Food Safety Management",
        "Information Security",
        "Occupational Health and Safety",
      ],
      // correctAnswer: "Food Safety Management"
    },
    {
      question:
        "Which clause of ISO 22000 deals with Hazard Analysis and Critical Control Points (HACCP)?",
      options: ["Clause 6", " Clause 7", " Clause 8", "Clause 9"],
      // correctAnswer: " Clause 8"
    },
    {
      question: "What does FSMS stand for in the context of ISO 22000?",
      options: [
        "Food Safety Monitoring System",
        "Food Supply Management System",
        "Food Safety Management System",
        "Food Service Management System",
      ],
      // correctAnswer: "Food Safety Management System"
    },
    {
      question: "Which of the following is NOT a core element of ISO 22000?",
      options: [
        "Prerequisite programs",
        "HACCP principles",
        "Quality control of non-food products",
        "Management system requirements",
      ],
      // correctAnswer: "Quality control of non-food products"
    },
    {
      question:
        "What is the purpose of conducting a hazard analysis in ISO 22000?",
      options: [
        "To enhance financial performance",
        "To identify and assess potential food safety hazards",
        "To improve employee satisfaction",
        " To increase market share",
      ],
      // correctAnswer: "To identify and assess potential food safety hazards"
    },
    {
      question:
        "Who is responsible for the implementation of the FSMS according to ISO 22000?",
      options: [
        " Middle management",
        "Quality control department",
        " Top management",
        "External auditors",
      ],
      // correctAnswer: " Top management"
    },
    {
      question:
        "What does the term “critical control point” (CCP) mean in ISO 22000?",
      options: [
        "A step where control can be applied to prevent or eliminate a food safety hazard",
        "A location for financial auditing",
        "A point of customer service interaction",
        "A step in the marketing process",
      ],
      // correctAnswer: "A step where control can be applied to prevent or eliminate a food safety hazard"
    },
    {
      question: "Which document outlines the scope of an organization's FSMS?",
      options: [
        "Quality Manual",
        "Food Safety Policy",
        "Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Food Safety Policy"
    },
    {
      question: "What role do internal audits play in ISO 22000?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the FSMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer: "They help ensure the FSMS is effectively implemented and maintained"
    },
    {
      question:
        "How often should the effectiveness of the FSMS be reviewed according to ISO 22000?",
      options: ["Daily", "Monthly", "Annually", "As Needed"],
      // correctAnswer: "Annually"
    },
  ],
  "ISO-27001 module-1": [
    {
      question: "What is the primary focus of ISO 27001?",
      options: [
        " Quality Management",
        "Environmental Management",
        "Information Security Management",
        "Occupational Health and Safety",
      ],
      // correctAnswer: "Information Security Management"
    },
    {
      question:
        "Which clause of ISO 27001 deals with the Context of the Organization?",
      options: ["Clause 4", "Clause 5", "Clause 6", "Clause 7"],
      // correctAnswer: "Clause 4"
    },
    {
      question: "What does ISMS stand for in the context of ISO 27001?",
      options: [
        "Information System Management Standard",
        "Information Security Management System",
        "International Security Management System",
        "Internet Security Management Standard",
      ],
      // correctAnswer: "Information Security Management System"
    },
    {
      question: "Which of the following is NOT a core component of ISO 27001?",
      options: [
        "Risk Assessment",
        "Physical Security",
        "Financial Auditing",
        "Security Controls",
      ],
      // correctAnswer: "Financial Auditing"
    },
    {
      question: "What is the purpose of a risk assessment in ISO 27001?",
      options: [
        "To evaluate financial performance",
        "To identify and manage information security risks",
        "To improve employee satisfaction",
        " To increase market share",
      ],
      // correctAnswer: "To identify and manage information security risks"
    },
    {
      question:
        "Who is responsible for ensuring the ISMS is effectively implemented and maintained according to ISO 27001?",
      options: [
        "Middle management",
        " IT department",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management"
    },
    {
      question: "What is an information asset according to ISO 27001?",
      options: [
        "Any data that has financial value",
        "Any data that is valuable to the organization",
        "Any data that can be sold",
        "Any data that is not used frequently",
      ],
      // correctAnswer: "Any data that is valuable to the organization"
    },
    {
      question: "Which document outlines the scope of an organization's ISMS?",
      options: [
        "Quality Manual",
        "Information Security Policy",
        " Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Information Security Policy"
    },
    {
      question: "What role do internal audits play in ISO 27001?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the ISMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer: "They help ensure the ISMS is effectively implemented and maintained"
    },
    {
      question:
        "How often should the effectiveness of the ISMS be reviewed according to ISO 27001?",
      options: ["Daily", "Monthly", "Annually ", "As Needed"],
      // correctAnswer: "Annually "
    },
  ],
  "ISO-22301 module-1": [
    {
      question: "What is the primary focus of ISO 22301?",
      options: [
        "Environmental Management",
        " Business Continuity Management",
        "Information Security",
        "Occupational Health and Safety",
      ],
      // correctAnswer: " Business Continuity Management"
    },
    {
      question:
        "Which clause of ISO 22301 deals with Context of the Organization?",
      options: ["Clause 4", "Clause 5", "Clause 6", "Clause 7"],
      // correctAnswer: "Clause 4"
    },
    {
      question:
        "What is the purpose of a Business Impact Analysis (BIA) in ISO 22301?",
      options: [
        "To assess financial performance",
        "To identify the impact of disruptions on business operationsthly",
        "To improve employee satisfaction",
        "To increase market share",
      ],
      // correctAnswer: "To identify the impact of disruptions on business operations"
    },
    {
      question: "What does BCMS stand for in the context of ISO 22301?",
      options: [
        "Business Control Management System",
        "Business Continuity Management System",
        "Business Compliance Management Standard",
        "Business Communication Management System",
      ],
      // correctAnswer: "Business Continuity Management System"
    },
    {
      question: "Which of the following is NOT a core element of ISO 22301?",
      options: [
        "Risk Assessment",
        "Financial Auditing",
        "Business Impact Analysis",
        "Incident Response",
      ],
      // correctAnswer: "Financial Auditing"
    },
    {
      question:
        "Who is responsible for ensuring the BCMS is effectively implemented and maintained according to ISO 22301?",
      options: [
        "Middle management",
        "Business continuity team",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management"
    },
    {
      question:
        "What is the significance of a Business Continuity Plan (BCP) according to ISO 22301?",
      options: [
        "To outline financial strategies",
        "To ensure environmental compliance",
        "To establish procedures for responding to disruptions",
        "To enhance marketing efforts",
      ],
      // correctAnswer: "To establish procedures for responding to disruptions"
    },
    {
      question: "Which document outlines the scope of an organization's BCMS?",
      options: [
        "Quality Manual",
        "Business Continuity Policy",
        "Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Business Continuity Policy"
    },
    {
      question: "What role do internal audits play in ISO 22301?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the BCMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer: "They help ensure the BCMS is effectively implemented and maintained"
    },
    {
      question:
        "How often should the effectiveness of the BCMS be reviewed according to ISO 22301?",
      options: ["Daily", "Monthly", "Annually", "As Needed"],
      // correctAnswer: "Annually"
    },
  ],
  "ISO-20000-1 module-1": [
    {
      question: "What is the primary objective of ISO 20000-1?",
      options: [
        "Quality Management",
        "IT Service Management",
        "Environmental Management",
        "Occupational Health and Safety",
      ],
      // correctAnswer: "IT Service Management"
    },
    {
      question:
        "Which clause of ISO 20000-1 deals with Service Delivery Processes?",
      options: ["Clause 4", "Clause 5", "Clause 6", " Clause 7"],
      // correctAnswer: " Clause 7"
    },
    {
      question: "What does ITSMS stand for in the context of ISO 20000-1?",
      options: [
        "Information Technology System Management",
        "Internet Technology Service Management",
        "IT Service Management System",
        " International Technology Standard Management",
      ],
      // correctAnswer: "IT Service Management System"
    },
    {
      question: "Which of the following is NOT a core process of ISO 20000-1?",
      options: [
        "Incident Management",
        "Service Level Management",
        "Financial Auditing",
        "Change Management",
      ],
      // correctAnswer: "Financial Auditing"
    },
    {
      question:
        "What is the purpose of a Service Level Agreement (SLA) according to ISO 20000-1?",
      options: [
        "To outline financial transactions",
        "To define the level of service expected by the customer",
        " To manage employee performance",
        "To ensure environmental compliance",
      ],
      // correctAnswer: "To define the level of service expected by the customer"
    },
    {
      question:
        "Who is responsible for ensuring the ITSMS is effectively implemented and maintained according to ISO 20000-1?",
      options: [
        "Middle management",
        "IT department",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management"
    },
    {
      question: "What is an incident in the context of ISO 20000-1?",
      options: [
        "A planned change to a service",
        "An unplanned interruption to a service or reduction in the quality of a service",
        "A scheduled maintenance activity",
        "A financial transaction error",
      ],
      // correctAnswer: "An unplanned interruption to a service or reduction in the quality of a service"
    },
    {
      question: "Which document outlines the scope of an organization's ITSMS?",
      options: [
        "Quality Manual",
        "Service Catalogue",
        "Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Service Catalogue"
    },
    {
      question: "What role do internal audits play in ISO 20000-1?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the ITSMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer: "They help ensure the ITSMS is effectively implemented and maintained"
    },
    {
      question:
        "How often should the effectiveness of the ITSMS be reviewed according to ISO 20000-1?",
      options: ["Daily", "Monthly", "Annually", "As Needed"],
      // correctAnswer: "Annually"
    },
  ],
  "ISO-27701 module-1": [
    {
      question: "What is the primary focus of ISO 27701?",
      options: [
        "Quality Management",
        "Environmental Management",
        " Privacy Information Management",
        "Occupational Health and Safety",
      ],
      // correctAnswer: " Privacy Information Management"
    },
    {
      question:
        "Which clause of ISO 27701 deals with Privacy Impact Assessments (PIAs)?",
      options: ["Clause 4", "Clause 5", "Clause 6", "Clause 7"],
      // correctAnswer: "Clause 7"
    },
    {
      question: "What does PIMS stand for in the context of ISO 27701?",
      options: [
        "Privacy Information Management System",
        "Public Information Management Standard",
        "Personal Information Management System",
        "Privacy Internal Management Scheme",
      ],
      // correctAnswer: "Privacy Information Management System"
    },
    {
      question: "Which of the following is NOT a core component of ISO 27701?",
      options: [
        "Risk Assessment",
        "Data Protection Impact Assessment",
        "Financial Auditing",
        "Privacy Controls",
      ],
      // correctAnswer: "Financial Auditing"
    },
    {
      question:
        "What is the purpose of a Data Protection Impact Assessment (DPIA) in ISO 27701?",
      options: [
        "To evaluate financial performance",
        "To identify and mitigate privacy risks",
        "To improve employee satisfaction",
        "To increase market share",
      ],
      // correctAnswer: "To identify and mitigate privacy risks"
    },
    {
      question:
        "Who is responsible for ensuring the PIMS is effectively implemented and maintained according to ISO 27701?",
      options: [
        "Middle management",
        "IT department",
        "Top management",
        "External auditors",
      ],
      // correctAnswer: "Top management"
    },
    {
      question: "What is a data subject according to ISO 27701?",
      options: [
        "An entity responsible for processing data",
        "An individual whose personal data is being processed",
        "A company that manages data",
        "A regulatory body overseeing data protection",
      ],
      // correctAnswer: "An individual whose personal data is being processed"
    },
    {
      question: "Which document outlines the scope of an organization's PIMS?",
      options: [
        "Quality Manual",
        "Privacy Policy",
        "Financial Report",
        "Employee Handbook",
      ],
      // correctAnswer: "Privacy Policy"
    },
    {
      question: "What role do internal audits play in ISO 27701?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the PIMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      // correctAnswer: "They help ensure the PIMS is effectively implemented and maintained"
    },
    {
      question:
        "How often should the effectiveness of the PIMS be reviewed according to ISO 27701?",
      options: ["Daily", "Monthly", "Annually", "As Needed"],
      // correctAnswer: "Annually"
    },
  ],
  "ISO-13485 module-1": [
    {
      question: "What is the primary focus of ISO 13485?",
      options: [
        "Environmental Management",
        "Quality Management for Medical Devices",
        "Information Security",
        "Occupational Health and Safety",
      ],
      // correctAnswer: "Quality Management for Medical Devices"
    },
    {
      question: "Which clause of ISO 13485 deals with Risk Management?",
      options: ["Clause 4", "Clause 7.1", "Clause 8.2", "Clause 6.2"],
      // correctAnswer: "Clause 7.1"
    },
    {
      question:
        "What is a key requirement of ISO 13485 related to medical device documentation?",
      options: [
        "It must be easy to read",
        "It must be organized and maintained in accordance with regulatory requirements",
        "It must be available in multiple languages",
        "It must be reviewed monthly",
      ],
      // correctAnswer: "It must be organized and maintained in accordance with regulatory requirementsly"
    },
    {
      question: "What does the term “Nonconforming Product” mean in ISO 13485?",
      options: [
        "A product that exceeds quality expectations",
        "A product that fails to meet specified requirements",
        "A product that is yet to be tested",
        " A product that is in high demand",
      ],
      // correctAnswer: "A product that fails to meet specified requirements"
    },
    {
      question:
        "Which of the following is NOT a part of the ISO 13485 standard?",
      options: [
        "Design and Development",
        "Production and Service Provision",
        " Human Resource Management",
        "Corrective and Preventive Actions",
      ],
      // correctAnswer: " Human Resource Management"
    },
    {
      question:
        "What is the purpose of internal audits according to ISO 13485?",
      options: [
        "To improve financial performance",
        "To identify areas for cost reduction",
        "To assess compliance with the QMS",
        "To ensure all employees are satisfied",
      ],
      // correctAnswer: "To assess compliance with the QMS"
    },
    {
      question:
        "What must be established for maintaining the effectiveness of the QMS under ISO 13485?",
      options: [
        "Regular employee training",
        " High-quality marketing materials",
        "Communication procedures",
        "Detailed financial reports",
      ],
      // correctAnswer: "Regular employee training"
    },
    {
      question:
        "Which ISO 13485 clause focuses on the management responsibility?",
      options: ["Clause 5", " Clause 6", " Clause 7", " Clause 8"],
      // correctAnswer: "Clause 5"
    },
    {
      question: "Why is risk management crucial in ISO 13485?",
      options: [
        " To increase product sales",
        "To improve employee morale",
        "To ensure the safety and performance of medical devices",
        "To reduce production costs",
      ],
      // correctAnswer: "To ensure the safety and performance of medical devices"
    },
    {
      question:
        "How often should the effectiveness of the QMS be reviewed according to ISO 13485?",
      options: ["Daily", "Monthly", "Annually", "As Needed"],
      // correctAnswer: "Annually"
    },
  ],
  "ISO-17025 module-1": [
    {
      question: "What is the primary focus of ISO 17025?",
      options: [
        "Environmental Management",
        "Occupational Health and Safety",
        "Competence of Testing and Calibration Laboratories",
        "Quality Management for Medical Devices",
      ],
      correctAnswer: "Competence of Testing and Calibration Laboratories",
    },
    {
      question: "Which clause in ISO 17025 deals with Management Requirements?",
      options: ["Clause 4", "Clause 5", "Clause 6", "Clause 7"],
      correctAnswer: "Clause 4",
    },
    {
      question:
        "What is the purpose of proficiency testing according to ISO 17025?",
      options: [
        "To enhance financial performance",
        "To validate the competence of laboratory testing",
        "To improve employee satisfaction",
        "To increase market share",
      ],
      correctAnswer: "To validate the competence of laboratory testing",
    },
    {
      question:
        "What does the term calibration mean in the context of ISO 17025?",
      options: [
        "Adjusting equipment to meet new specifications",
        "Comparing measurements to a standard to ensure accuracy",
        "Replacing old equipment with new technology",
        "Performing routine maintenance on laboratory instruments",
      ],
      correctAnswer: "Comparing measurements to a standard to ensure accuracy",
    },
    {
      question: "Which of the following is NOT a requirement under ISO 17025?",
      options: [
        "Technical competence",
        "Financial auditing",
        "Quality management",
        "Calibration of equipment",
      ],
      correctAnswer: "Financial auditing",
    },
    {
      question:
        "Who is responsible for the implementation of ISO 17025 in a laboratory?",
      options: [
        "Middle management",
        "Laboratory staff",
        "Top management",
        "External auditors",
      ],
      correctAnswer: "Top management",
    },
    {
      question: "What is the significance of traceability in ISO 17025?",
      options: [
        "To track financial transactions",
        "To ensure that measurements can be related to national or international standards",
        "To monitor employee performance",
        "To manage inventory effectively",
      ],
      correctAnswer:
        "To ensure that measurements can be related to national or international standards",
    },
    {
      question:
        "Which document outlines the general requirements for the competence of testing and calibration laboratories under ISO 17025?",
      options: [
        "Quality Manual",
        "Environmental Policy",
        "Laboratory Accreditation Standard",
        "Employee Handbook",
      ],
      correctAnswer: "Laboratory Accreditation Standard",
    },
    {
      question:
        "What is an interlaboratory comparison in the context of ISO 17025?",
      options: [
        "Comparing financial performance between laboratories",
        "Comparing test results from different laboratories to ensure consistency",
        "Comparing marketing strategies between laboratories",
        "Comparing human resource policies between laboratories",
      ],
      correctAnswer:
        "Comparing test results from different laboratories to ensure consistency",
    },
    {
      question:
        "How often should the effectiveness of the management system be reviewed according to ISO 17025?",
      options: ["Daily", "Monthly", "Annually", "As needed"],
      correctAnswer: "Annually",
    },
  ],
  "ISO-50001 module-1": [
    {
      question: "What is the primary focus of ISO 50001?",
      options: [
        "Quality Management",
        "Environmental Management",
        "Energy Management",
        "Occupational Health and Safety",
      ],
      correctAnswer: "Energy Management",
    },
    {
      question: "Which clause of ISO 50001 deals with Energy Planning?",
      options: ["Clause 4", "Clause 5", "Clause 6", "Clause 7"],
      correctAnswer: "Clause 6",
    },
    {
      question: "What does EnMS stand for in the context of ISO 50001?",
      options: [
        "Environmental Management System",
        "Energy Management System",
        "Enterprise Management System",
        "Efficiency Management System",
      ],
      correctAnswer: "Energy Management System",
    },
    {
      question: "Which of the following is NOT a core component of ISO 50001?",
      options: [
        "Energy Review",
        "Energy Performance Indicators",
        "Financial Auditing",
        "Energy Baseline",
      ],
      correctAnswer: "Financial",
    },
    {
      question: "What is the purpose of an energy review in ISO 50001?",
      options: [
        "To evaluate financial performance",
        "To identify and evaluate energy use and consumption",
        "To improve employee satisfaction",
        "To increase market share",
      ],
      correctAnswer: "To identify and evaluate energy use and consumption",
    },
    {
      question:
        "Who is responsible for ensuring the EnMS is effectively implemented and maintained according to ISO 50001?",
      options: [
        "Middle management",
        "Energy management team",
        "Top management",
        "External auditors",
      ],
      correctAnswer: "Top management",
    },
    {
      question:
        "What is an energy performance indicator (EnPI) according to ISO 50001?",
      options: [
        "A measure of financial performance",
        "A metric used to quantify energy performance",
        "A target for reducing energy costs",
        "A benchmark for environmental compliance",
      ],
      correctAnswer: "A metric used to quantify energy performance",
    },
    {
      question: "Which document outlines the scope of an organization's EnMS?",
      options: [
        "Quality Manual",
        "Energy Policy",
        "Financial Report",
        "Employee Handbook",
      ],
      correctAnswer: "Energy Policy",
    },
    {
      question: "What role do internal audits play in ISO 50001?",
      options: [
        "They are optional and conducted at the discretion of the company",
        "They are performed only by external auditors",
        "They help ensure the EnMS is effectively implemented and maintained",
        "They focus primarily on financial performance",
      ],
      correctAnswer:
        "They help ensure the EnMS is effectively implemented and maintained",
    },
    {
      question:
        "How often should the effectiveness of the EnMS be reviewed according to ISO 50001?",
      options: ["Daily", "Monthly", "Annually", "As needed"],
      correctAnswer: "Annually",
    },
  ],
  "GMP module-1": [
    {
      question: "What does GMP stand for in the context of manufacturing?",
      options: [
        "General Manufacturing Procedures",
        "Good Manufacturing Practices",
        "Global Manufacturing Policies",
        "General Manufacturing Policies",
      ],
      correctAnswer: "Good Manufacturing Practices",
    },
    {
      question: "Which of the following is a primary goal of GMP?",
      options: [
        "To ensure product quality and safety",
        "To increase production speed",
        "To reduce employee workload",
        "To enhance marketing strategies",
      ],
      correctAnswer: "To ensure product quality and safety",
    },
    {
      question:
        "What is the significance of maintaining clean and hygienic manufacturing environments according to GMP?",
      options: [
        "To prevent contamination",
        "Monthly",
        "To reduce energy consumption",
        "To enhance product packaging",
      ],
      correctAnswer: "To prevent contamination",
    },
    {
      question: "Which of the following is NOT a component of GMP?",
      options: [
        "Personnel qualifications",
        "Equipment maintenance",
        "Financial auditing",
        "Quality control",
      ],
      correctAnswer: "Financial auditing",
    },
    {
      question: "What is the purpose of GMP documentation?",
      options: [
        "To provide legal protection",
        "To ensure consistency and traceability",
        "To enhance marketing efforts",
        "To reduce production costs",
      ],
      correctAnswer: "To ensure consistency and traceability",
    },
    {
      question:
        "Who is responsible for implementing GMP in a manufacturing facility?",
      options: [
        "Only the quality control department",
        "All employees",
        "Only the top management",
        "External auditors",
      ],
      correctAnswer: "All employees",
    },
    {
      question:
        "What does GMP require regarding the handling of raw materials?",
      options: [
        "They should be stored in any available space",
        "They should be inspected upon arrival",
        "They should be used immediately",
        "They should be stored without labels",
      ],
      correctAnswer: "They should be inspected upon arrival",
    },
    {
      question: "Which of the following is a key principle of GMP?",
      options: [
        "Minimizing employee training",
        "Ignoring equipment maintenance",
        "Ensuring proper sanitation",
        "Reducing documentation",
      ],
      correctAnswer: "Ensuring proper sanitation",
    },
    {
      question: "What is the role of GMP in product recalls?",
      options: [
        "To complicate the recall process",
        "To ensure quick and effective recalls",
        "To avoid recalls altogether",
        "To increase recall costs",
      ],
      correctAnswer: "To ensure quick and effective recalls",
    },
    {
      question: "How often should GMP training be conducted for employees?",
      options: [
        "Once at hiring",
        "Annually",
        "Every five years",
        "Only when there are changes in procedures",
      ],
      correctAnswer: "Annually",
    },
  ],
  "HACCP module-1": [
    {
      question: "What does HACCP stand for?",
      options: [
        "Hazard Analysis and Critical Control Points",
        "Health and Safety Control Plan",
        "Hazard Assessment and Control Procedures",
        "High Accuracy Control Protocol",
      ],
      correctAnswer: "Hazard Analysis and Critical Control Points",
    },
    {
      question: "What is the primary purpose of HACCP?",
      options: [
        "To improve financial performance",
        "To ensure food safety",
        "To reduce employee workload",
        "To enhance marketing strategies",
      ],
      correctAnswer: "To ensure food safety",
    },
    {
      question: "Which of the following is the first principle of HACCP?",
      options: [
        "Establish critical limits",
        "Conduct a hazard analysis",
        "Establish corrective actions",
        "Verify the system works",
      ],
      correctAnswer: "Conduct a hazard analysis",
    },
    {
      question:
        "What are Critical Control Points (CCPs) in the context of HACCP?",
      options: [
        "Steps where financial audits are performed",
        "Steps where control can be applied to prevent or eliminate a food safety hazard",
        "Points where employee performance is evaluated",
        "Steps where marketing strategies are developed",
      ],
      correctAnswer:
        "Steps where control can be applied to prevent or eliminate a food safety hazard",
    },
    {
      question:
        "Which HACCP principle involves establishing procedures to monitor CCPs?",
      options: ["Principle 2", "Principle 3", "Principle 4", "Principle 5"],
      correctAnswer: "Principle 4",
    },
    {
      question: "Why is it important to establish critical limits in HACCP?",
      options: [
        "To improve financial performance",
        "To define acceptable levels of hazards at CCPs",
        "To increase production speed",
        "To enhance product packaging",
      ],
      correctAnswer: "To define acceptable levels of hazards at CCPs",
    },
    {
      question:
        "What should be done if a critical limit is not met according to HACCP principles?",
      options: [
        "Ignore the issue",
        "Establish corrective actions to bring the process back under control",
        "Report it to the marketing team",
        "Increase production speed",
      ],
      correctAnswer:
        "Establish corrective actions to bring the process back under control",
    },
    {
      question: "Which of the following is NOT a principle of HACCP?",
      options: [
        "Conduct a hazard analysis",
        "Establish critical limits",
        "Perform a financial audit",
        "Verify the system works",
      ],
      correctAnswer: "Perform a financial audit",
    },
    {
      question: "What is the role of verification procedures in HACCP?",
      options: [
        "To ensure marketing strategies are effective",
        "To confirm that the HACCP plan is working correctly",
        "To assess employee performance",
        "To increase production efficiency",
      ],
      correctAnswer: "To confirm that the HACCP plan is working correctly",
    },
    {
      question: "How often should the HACCP system be reviewed?",
      options: ["Daily", "Monthly", "Annually", "As needed"],
      correctAnswer: "As needed",
    },
  ],
  "SOC-2 module-1": [
    {
      question: "What is the primary focus of SOC 2?",
      options: [
        "Financial Reporting",
        "Customer Service",
        "Trust Service Principles",
        "Environmental Management",
      ],
      correctAnswer: "Trust Service Principles",
    },
    {
      question:
        "Which of the following is NOT one of the five trust service principles in SOC 2?",
      options: [
        "Security",
        "Confidentiality",
        "Financial Control",
        "Processing Integrity",
      ],
      correctAnswer: "Financial Control",
    },
    {
      question: "What does SOC in SOC 2 stand for?",
      options: [
        "Service Organization Control",
        "Security of Control",
        "Systems Operating Control",
        "Standards of Compliance",
      ],
      correctAnswer: "Service Organization Control",
    },
    {
      question:
        "Which SOC 2 principle focuses on protecting data from unauthorized access?",
      options: ["Privacy", "Availability", "Security", "Processing Integrity"],
      correctAnswer: "Security",
    },
    {
      question: "What is the purpose of a SOC 2 audit?",
      options: [
        "To evaluate financial performance",
        "To assess compliance with trust service principles",
        "To improve customer satisfaction",
        "To enhance marketing strategies",
      ],
      correctAnswer: "To assess compliance with trust service principles",
    },
    {
      question: "Who typically performs a SOC 2 audit?",
      options: [
        "Internal employees",
        "External auditors",
        "Customers",
        "IT department",
      ],
      correctAnswer: "External auditors",
    },
    {
      question: "What is a key benefit of achieving SOC 2 certification?",
      options: [
        "Increased production speed",
        "Enhanced data security and trustworthiness",
        "Reduced marketing costs",
        "Higher employee turnover",
      ],
      correctAnswer: "Enhanced data security and trustworthiness",
    },
    {
      question:
        "Which SOC 2 principle addresses the need for the system to be available for operation and use as agreed?",
      options: ["Security", "Privacy", "Availability", "Confidentiality"],
      correctAnswer: "Availability",
    },
    {
      question:
        "How often should SOC 2 audits be conducted to ensure ongoing compliance?",
      options: ["Daily", "Monthly", "Annually", "Every five years"],
      correctAnswer: "Annually",
    },
    {
      question:
        "Which SOC 2 principle relates to how personal information is collected, used, retained, and disclosed?",
      options: ["Security", "Processing", "Privacy", "Confidentiality"],
      correctAnswer: "Privacy",
    },
  ],
  "ISO-55001 module-1": [
    {
      question: "What is the primary purpose of ISO 55001?",
      options: [
        "To list all assets in an organization.",
        "To set requirements for an Asset Management System.",
        "To provide a checklist for maintenance technicians.",
        "To replace ISO 9001.",
      ],
      correctAnswer: "To set requirements for an Asset Management System.",
    },
    {
      question:
        "Which of the following is NOT one of the key pillars of the ISO 55001 AMS?",
      options: ["Value", "Alignment", "Marketing", "Leadership"],
      correctAnswer: "Marketing",
    },
    {
      question:
        "According to ISO 55001, which document should outline the top-level plan for asset management?",
      options: [
        "The Purchase Order.",
        "The Strategic Asset Management Plan (SAMP).",
        "The Daily Log.",
        "The Employee Handbook.",
      ],
      correctAnswer: "The Strategic Asset Management Plan (SAMP).",
    },
    {
      question: 'What does the "lifecycle" in ISO 55001 refer to?',
      options: [
        "The time it takes to build an asset.",
        "The duration an asset is owned by the organization.",
        "The entire period from asset planning to disposal.",
        "The warranty period of an asset.",
      ],
      correctAnswer: "The entire period from asset planning to disposal.",
    },
    {
      question:
        "Who is responsible for ensuring the asset management policy is established?",
      options: [
        "The maintenance manager.",
        "The operator.",
        "Top management.",
        "The HR department.",
      ],
      correctAnswer: "Top management.",
    },
    {
      question:
        "Which clause in ISO 55001:2024 formally introduces the Strategic Asset Management Plan (SAMP)?",
      options: [
        "Clause 4 (Context)",
        "Clause 5 (Leadership)",
        "Clause 6 (Planning)",
        "Clause 9 (Performance Evaluation)",
      ],
      correctAnswer: "Clause 6 (Planning)",
    },
    {
      question:
        "Effective asset management under ISO 55001 helps organizations to:",
      options: [
        "Increase risk exposure.",
        "Lower total cost of ownership.",
        "Reduce the need for audits.",
        "Eliminate all maintenance costs.",
      ],
      correctAnswer: "Lower total cost of ownership.",
    },
    {
      question: "What is a key benefit of complying with ISO 55001?",
      options: [
        "Improved stakeholder confidence.",
        "Increased unplanned downtime.",
        "Higher administrative burden.",
        "Less focus on sustainability.",
      ],
      correctAnswer: "Improved stakeholder confidence.",
    },
    {
      question:
        "Key role of asset management is to assure the delivery of value in line with:",
      options: [
        "Agreed performance / levels of service",
        "Return on Investment (ROI) and/or Return on Net Assets (RONA)",
        "Required residual risk profile",
        "All True",
      ],
      correctAnswer: "All True",
    },
    {
      question:
        "What is one of the most important elements of asset management?",
      options: [
        "Company profile",
        "The control of management risk",
        "The role of organizational culture",
        "None of above",
      ],
      correctAnswer: "None of above",
    },
  ],
  "GMP module-1": [
    {
      question: "What does GMP stand for? ",
      options: [
        "General Manufacturing Process",
        "Good Manufacturing Practice",
        "Global Manufacturing Procedure",
        "Government Manufacturing Policy ",
      ],
      correctAnswer: "Good Manufacturing Practice",
    },
    {
      question: " The main purpose of GMP is to ensure:",
      options: [
        " Products are manufactured cheaply",
        " Higher sales  ",
        "Faster production",
        "Products are consistently produced and controlled according to quality standards   ",
      ],
      correctAnswer:
        "Products are consistently produced and controlled according to quality standards",
    },
    {
      question: " Which of the following is a key principle of GMP? ",
      options: [
        "Documentation",
        "Advertising",
        "Sales tracking",
        "Marketing strategy",
      ],
      correctAnswer: "Documentation",
    },
    {
      question:
        "Which document provides detailed instructions to perform a specific task?",
      options: [
        "SOP (Standard Operating Procedure)",
        "Invoice",
        "Brochure",
        "Audit report",
      ],
      correctAnswer: "SOP (Standard Operating Procedure) ",
    },
    {
      question: " Batch Manufacturing Record (BMR) contains: ",
      options: [
        "Employee salary details",
        " Complete history of manufacturing of a batch",
        "Marketing plan",
        "Customer complaints only",
      ],
      correctAnswer: " Complete history of manufacturing of a batch",
    },
    {
      question:
        " Which department is primarily responsible for approving or rejecting finished products?",
      options: [
        "Sales",
        "Human Resources",
        " Quality Control (QC)",
        "Maintenance",
      ],
      correctAnswer: " Quality Control (QC)",
    },
    {
      question: "Personal hygiene is important in GMP to prevent: ",
      options: [
        "Equipment breakdown",
        "Product contamination",
        "Production delay",
        "Power failure",
      ],
      correctAnswer: "Product contamination",
    },
    {
      question: "Validation in GMP means:",
      options: [
        "Checking employee attendance",
        "Confirming a process consistently produces expected results",
        "Increasing production speed",
        "Reducing cost",
      ],
      correctAnswer:
        "Confirming a process consistently produces expected results",
    },
    {
      question: "Change control in GMP is used to:",
      options: [
        "Change employee shifts",
        "Manage and document changes that may affect product quality",
        "Change company logo",
        " Replace old equipment only",
      ],
      correctAnswer:
        "Manage and document changes that may affect product quality",
    },
    {
      question: "A deviation in GMP is:?",
      options: [
        "A planned activity",
        "A departure from an approved instruction or standard",
        "A marketing strategy",
        " A financial report",
      ],
      correctAnswer: "A departure from an approved instruction or standard",
    },
  ],
  "GDP module-1": [
    {
      question: "What does GDP stand for? ",
      options: [
        "General Distribution Process",
        "Good Distribution Practice",
        "Global Delivery Procedure",
        "Government Dispatch Policy ",
      ],
      correctAnswer: "Good Distribution Practice",
    },
    {
      question: " The main purpose of GDP is to:",
      options: [
        "Ensure quality and integrity of medicinal products throughout the supply chain ",
        "Increase product sales",
        "Reduce transportation cost",
        "Speed up delivery",
      ],
      correctAnswer:
        "Ensure quality and integrity of medicinal products throughout the supply chain",
    },
    {
      question: "GDP guidelines in the European Union are published by: ",
      options: [
        "World Trade Organization ",
        "World Health Organization ",
        "Food and Drug Administration",
        "European Commission",
      ],
      correctAnswer: "European Commission",
    },
    {
      question: "Which of the following is a key GDP requirement?",
      options: [
        "Advertising approval",
        " Sales target monitoring",
        "Temperature control during transportation ",
        "Production validation",
      ],
      correctAnswer: "Temperature control during transportation  ",
    },
    {
      question: "Returned medicinal products should be: ",
      options: [
        "Immediately resold ",
        "Evaluated to ensure quality before being returned to saleable stock",
        "Disposed without review",
        "Sent back to customers",
      ],
      correctAnswer:
        "Evaluated to ensure quality before being returned to saleable stock",
    },
    {
      question: "Documentation in GDP ensures:",
      options: [
        "Verifiable traceability of products",
        "Faster transportation",
        "Reduced paperwork",
        "Higher marketing efficiency",
      ],
      correctAnswer: "Verifiable traceability of products",
    },
    {
      question:
        " Which of the following is important to prevent falsified medicines entering the supply chain? ",
      options: [
        "Supplier qualification and verification",
        "Increasing batch size",
        " Lower pricing",
        "Reducing inspections",
      ],
      correctAnswer: " Supplier qualification and verification",
    },
    {
      question: "Vehicles used for medicinal product transport should:",
      options: [
        "Be used for any type of goods",
        "Be suitable and, where necessary, temperature-controlled",
        "Have no documentation",
        "Be uncleaned",
      ],
      correctAnswer: "Be suitable and, where necessary, temperature-controlled",
    },
    {
      question: "Personnel involved in distribution must:",
      options: [
        "Be trained in GDP requirements",
        "Know only delivery routes",
        "Focus only on sales",
        "Avoid documentation",
      ],
      correctAnswer: "Be trained in GDP requirements",
    },
    {
      question: " Self-inspections in GDP are conducted to:",
      options: [
        "Replace regulatory inspections",
        "Verify ongoing compliance with GDP requirements",
        "Reduce workload",
        "Increase transportation speed",
      ],
      correctAnswer: "Verify ongoing compliance with GDP requirements",
    },
  ],
  "HACCP module-1": [
    {
      question: "What is the main objective of HACCP?",
      options: [
        "Increase production",
        "Ensure food safety",
        "Reduce employee workload",
        " Improve packaging design",
      ],
      correctAnswer: "Ensure food safety",
    },
    {
      question: "HACCP stands for:",
      options: [
        "Hazard Analysis Critical Control Process",
        "Hazard Analysis and Critical Control Points",
        "Health and Control Critical Process",
        " Hazard Assessment and Control Plan",
      ],
      correctAnswer: "Hazard Analysis and Critical Control Points",
    },
    {
      question: "Which of the following is a biological hazard?",
      options: [
        "Glass pieces",
        "Cleaning chemical residue",
        "Salmonella bacteria",
        "Metal fragments",
      ],
      correctAnswer: "Salmonella bacteria",
    },
    {
      question: " A CCP is best described as:",
      options: [
        "Final inspection step",
        "Quality objective",
        "Storage location",
        "A step where control prevents or eliminates a hazard",
      ],
      correctAnswer: "A step where control prevents or eliminates a hazard",
    },
    {
      question: "Which of the following is a physical hazard?",
      options: ["Virus", "Pesticide residue", "Hair in food", "Bacteria"],
      correctAnswer: "Hair in food",
    },
    {
      question: " Critical limits are:",
      options: [
        "Production targets",
        "Legal working hours",
        "Maximum or minimum values to control a hazard",
        "Customer requirements",
      ],
      correctAnswer: "Maximum or minimum values to control a hazard",
    },
    {
      question: "Monitoring in HACCP means:",
      options: [
        "Watching employees",
        "Checking whether CCP is under control",
        "Marketing food products",
        "Supervising suppliers",
      ],
      correctAnswer: "Checking whether CCP is under control",
    },
    {
      question: "Corrective action is taken when:",
      options: [
        " Production increases",
        "Audit is scheduled",
        "A CCP exceeds critical limits",
        "Customer places order",
      ],
      correctAnswer: "A CCP exceeds critical limits",
    },
    {
      question: "HACCP is mainly applied in:",
      options: [
        "Construction industry",
        "Banking sector",
        "Food production and processing",
        "Automobile manufacturing",
      ],
      correctAnswer: "Food production and processing",
    },
    {
      question: "HACCP documentation provides:",
      options: [
        "Evidence of food safety control",
        "Sales records",
        "Financial statements",
        "Employee contracts",
      ],
      correctAnswer: "Evidence of food safety control",
    },
  ],
  "GDPR module-1": [
    {
      question: "What does GDPR stand for? ",
      options: [
        "General Data Privacy Regulation",
        "General Data Protection Regulation",
        "Global Data Protection Rights",
        "General Digital Privacy Rules",
      ],
      correctAnswer: " General Data Protection Regulation",
    },
    {
      question: "GDPR applies to:",
      options: [
        " Only organizations located in Europe",
        "Only government agencies",
        "Any organization processing personal data of EU residents",
        "Only banks",
      ],
      correctAnswer:
        "Any organization processing personal data of EU residents",
    },
    {
      question: "What is considered personal data under GDPR? ",
      options: [
        " Only financial data",
        "Only names and email addresses",
        "Any information relating to an identified or identifiable natural person",
        "Only sensitive data like health records",
      ],
      correctAnswer:
        "Any information relating to an identified or identifiable natural person",
    },
    {
      question: " Consent under GDPR must be:",
      options: [
        "mplied automatically",
        "Freely given, specific, informed, and unambiguous",
        "Forced",
        "Optional for organizations",
      ],
      correctAnswer: "Freely given, specific, informed, and unambiguous",
    },
    {
      question: " A Data Controller is:",
      options: [
        " Government Agency",
        "Employee only",
        "Software tool",
        "Entity deciding purpose and means of processing",
      ],
      correctAnswer: "Entity deciding purpose and means of processing",
    },
    {
      question: "A DATA Processor is:",
      options: [
        "Entity processing data on behalf of controller",
        "HCustomer",
        "Regulator",
        "Auditor",
      ],
      correctAnswer: "Entity processing data on behalf of controller",
    },
    {
      question:
        "Which right allows individuals to request deletion of their data?",
      options: [
        "Right to Access",
        "Right to Rectification",
        "Right to Erasure",
        "Right to Objects",
      ],
      correctAnswer: "Right to Erasure",
    },
    {
      question:
        "How soon should a personal data breach be reported to authorities?",
      options: ["24 hours", "48 hours", "72 hours", "7 days"],
      correctAnswer: "72 hours",
    },
    {
      question: "What is Data Minimization? ",
      options: [
        "Collect maximum data",
        "Collect only necessary data",
        "Store data forever",
        "Share data publicly",
      ],
      correctAnswer: "Collect only necessary data",
    },
    {
      question:
        "Which of the following is a lawful basis for processing personal data? ",
      options: [
        "Consent",
        " Legal obligation",
        "Contract necessity",
        "All of the above",
      ],
      correctAnswer: "All of the above",
    },
  ],
  "HIPAA module-1": [
    {
      question: "What does HIPAA stand for?",
      options: [
        "Health Insurance Privacy and Accountability Act",
        "Health Insurance Portability and Accountability Act",
        " Healthcare Information Protection and Access Act",
        "Health Information Privacy and Authorization Act",
      ],
      correctAnswer: "Health Insurance Portability and Accountability Act",
    },
    {
      question: "What is Protected Health Information (PHI)?",
      options: [
        " Any medical information stored in a hospital",
        "Health information that identifies an individual",
        " Only electronic health records",
        "Only billing information",
      ],
      correctAnswer: "Health information that identifies an individual",
    },
    {
      question: "Which of the following is an example of PHI? ",
      options: [
        " Patient name with diagnosis",
        "Hospital address",
        "Doctor’s office phone number",
        " Medical textbook",
      ],
      correctAnswer: " Patient name with diagnosis",
    },
    {
      question: "Who must comply with HIPAA?",
      options: [
        " Healthcare provider’s",
        "Health insurance companies",
        "Healthcare clearinghouses",
        "All of the above",
      ],
      correctAnswer: "All of the above",
    },
    {
      question: "Which rule protects electronic PHI (ePHI)? ",
      options: [
        "Privacy Rule",
        "Security Rule",
        "Breach Notification Rule",
        "Enforcement Rule",
      ],
      correctAnswer: "Security Rule",
    },
    {
      question: "When can PHI be shared without patient authorization?",
      options: [
        "For treatment, payment, and healthcare operations",
        "For personal curiosity",
        "With friends",
        "On social media",
      ],
      correctAnswer: "For treatment, payment, and healthcare operations",
    },
    {
      question: " What is the minimum necessary standard? ",
      options: [
        "Share all patient information",
        "Share only the information needed to perform a task",
        "Share information only with management",
        "Do not share any information",
      ],
      correctAnswer: "Share only the information needed to perform a task",
    },
    {
      question: "What is the main purpose of HIPAA?",
      options: [
        "To increase hospital profits",
        "To protect sensitive patient health information",
        "To regulate insurance pricing",
        "To monitor doctors’ performance",
      ],
      correctAnswer: "To protect sensitive patient health information",
    },
    {
      question: "What should you do before leaving your workstation? :",
      options: [
        "Leave it open",
        " Log off or lock the computer ",
        "Turn off the monitor only",
        "Nothing",
      ],
      correctAnswer: " Log off or lock the computer ",
    },
    {
      question: "What is considered a HIPAA violation? ",
      options: [
        " Accessing patient records without authorization",
        " Following company policy",
        "Reporting incidents",
        "Encrypting datat",
      ],
      correctAnswer: "Accessing patient records without authorization",
    },
  ],
  "FSSC 22000 module-1": [
    {
      question: "Which standard forms the main foundation of FSSC 22000?  ",
      options: ["ISO 9001", "ISO 14001", "ISO 22000", "ISO 45001"],
      correctAnswer: "ISO 22000",
    },
    {
      question: "Who developed Version 6 of FSSC 22000? ",
      options: [
        "Codex Alimentarius",
        "European Commission",
        "The FSSC Foundation ",
        "WHO",
      ],
      correctAnswer: "The FSSC Foundation ",
    },
    {
      question:
        "Apart from ISO 22000 and PRPs, what else is included in the FSSC 22000 certification scheme? ",
      options: [
        "Only GMP",
        "Only HACCP",
        "Additional requirements specific to FSSC",
        "BRC standards",
      ],
      correctAnswer: "Additional requirements specific to FSSC",
    },
    {
      question:
        "The HACCP principles are based on guidelines from which organization? ",
      options: ["FAO", "WHO", " Codex Alimentarius Commission", "FDA"],
      correctAnswer: " Codex Alimentarius Commission",
    },
    {
      question:
        "Which prerequisite program (PRP) standard is commonly applied in food manufacturing? ",
      options: ["ISO/TS 22002-1 ", "ISO 17025", "ISO 13485", "ISO 50001"],
      correctAnswer: "ISO/TS 22002-1 ",
    },
    {
      question: "Food safety hazards can be: ",
      options: [
        "Only physical",
        "Only chemical",
        "Only biological",
        "Biological, chemical, and physical",
      ],
      correctAnswer: "Biological, chemical, and physical",
    },
    {
      question: "In FSSC 22000 Version 6, food safety culture focuses on:",
      options: [
        " Financial audits",
        "Management commitment and employee awareness",
        "Hiring external consultants",
        "Marketing strategies",
      ],
      correctAnswer: "Management commitment and employee awareness",
    },
    {
      question: "What is the main goal of FSSC 22000? ",
      options: [
        " Raise product prices ",
        "Improve food taste ",
        "Ensure food safety across the supply chain",
        "Reduce taxes",
      ],
      correctAnswer: "Ensure food safety across the supply chain",
    },
    {
      question: "Which organization owns ISO 22000? ",
      options: [
        "FDA",
        "ISO (International Organization for Standardization)",
        "FSSAI",
        "USDA",
      ],
      correctAnswer: "ISO (International Organization for Standardization)y",
    },
    {
      question: "Who grants FSSC 22000 certification? ",
      options: [
        "The company itself",
        "Customers",
        "Accredited Certification Bodies",
        "Government ministry",
      ],
      correctAnswer: "Accredited Certification Bodies",
    },
  ],
  "27017 2015 module-1": [
    {
      question: "ISO/IEC 27017 provides guidance for:",
      options: [
        " Environmental management",
        "Cloud security controls",
        "Financial auditing",
        "Occupational health",
      ],
    },
    {
      question: "ISO/IEC 27017 is an extension of:",
      options: ["ISO 9001", "ISO 14001", "ISO/IEC 27001", "ISO 45001"],
    },
    {
      question: "Cloud service provider (CSP) is an organization that:",
      options: [
        "Uses cloud services",
        "Audits cloud systems",
        "Certifies ISO standards",
        "Offers cloud services",
      ],
    },
    {
      question: "Cloud service customer is the entity that:",
      options: [
        "Delivers internet services",
        " Uses cloud services",
        "Regulates cloud providers",
        "Develops ISO standards",
      ],
    },
    {
      question: "A key concept in ISO 27017 is:",
      options: [
        "Shared responsibility model",
        "Sales performance",
        "Manufacturing control",
        "Product labeling",
      ],
    },
    {
      question:
        "Virtual machine configuration security is primarily related to:",
      options: [
        "Physical building security",
        "Cloud-specific controls",
        "Employee training",
        "Marketing plan",
      ],
    },
    {
      question:
        " Removal of cloud customer assets after contract termination should ensure:",
      options: [
        "Cost reduction",
        " Data security",
        "Faster renewal",
        "Public access",
      ],
    },
    {
      question: " Segregation in cloud computing helps to:",
      options: [
        "Increase profit",
        "Separate customer environments",
        "Reduce documentation",
        " Improve advertising",
      ],
    },
    {
      question: "Monitoring of cloud services helps in:",
      options: [
        "Detecting security incidents",
        "Designing logos",
        " Reducing tax",
        "Hiring staff",
      ],
    },
    {
      question: "Cloud security controls aim to protect:",
      options: [
        " Only hardware",
        "Only employees",
        "Information in cloud environment",
        "Only physical offices",
      ],
    },
  ],
  "GLP module-1": [
    {
      question: "What does GLP stand for?",
      options: [
        "General Laboratory Procedures.",
        "Good Laboratory Practice.",
        "Global Laboratory Policy.",
        "Government Laboratory Program.",
      ],
    },
    {
      question: "The main objective of GLP is to?",
      options: [
        "Increase laboratory profits",
        "Ensure quality, integrity, and reliability of laboratory data",
        "Reduce laboratory staff",
        "Eliminate documentation",
      ],
    },
    {
      question: "GLP primarily applies to?",
      options: [
        "Clinical diagnosis only.",
        "Non-clinical laboratory safety studies.",
        "Banking systems.",
        "Marketing research.",
      ],
    },
    {
      question: "Which document describes how a study will be conducted?",
      options: [
        "Study Plan / Protocol .",
        "Invoice.",
        "Marketing Report.",
        "Purchase Order.",
      ],
    },
    {
      question: "Who is responsible for the overall conduct of a GLP study  ?",
      options: [
        "Quality Assurance Unit.",
        "Study Director.",
        "Laboratory Technician.",
        "Data Entry Operator.",
      ],
    },
    {
      question: "What is the purpose of Standard Operating Procedures (SOPs)",
      options: [
        "Replace staff training",
        "Ensure consistency and standardization of procedures",
        "Reduce documentation",
        "Eliminate quality checks",
      ],
    },
    {
      question: "Raw data in GLP refers to",
      options: [
        "Final summary reports.",
        "Original observations and records generated during a study.",
        "Marketing data.",
        "Financial statements.",
      ],
    },
    {
      question: "The Quality Assurance Unit (QAU) is responsible for?",
      options: [
        "Conducting experiments.",
        "Monitoring compliance with GLP.",
        "Marketing laboratory services.",
        "Approving salaries.",
      ],
    },
    {
      question: "GLP requires records and samples to be:",
      options: [
        "Destroyed immediately",
        "Archived securely for future reference",
        "Shared publicly",
        "Ignored after reporting",
      ],
    },
    {
      question: "Calibration of laboratory instruments ensures?",
      options: [
        "Instruments look new",
        "Accurate and reliable results",
        "Faster experiments",
        "Reduced documentation",
      ],
    },
  ],
  "ISO-41001 module-1": [
    {
      question: "What does ISO 41001 relate to?",
      options: [
        "Information Security Management",
        "Facility Management System",
        "Food Safety Management",
        "Medical Device Quality",
      ],
      // correctAnswer: "Facility Management System",
    },
    {
      question: "The primary objective of ISO 41001 is to:",
      options: [
        "Increase production only",
        "Ensure effective and efficient facility management supporting organizational objectives",
        "Eliminate all maintenance activities",
        "Focus only on cleaning services",
      ],
      // correctAnswer: "Ensure effective and efficient facility management supporting organizational objectives",
    },
    {
      question: "ISO 41001 can be applied to:",
      options: [
        "Only construction companies",
        "Only hospitals",
        "Any organization managing facilities and support services",
        "Only manufacturing units",
      ],
      // correctAnswer: "Any organization managing facilities and support services",
    },
    {
      question: "Facility Management in ISO 41001 mainly integrates:",
      options: [
        "Sales and Marketing",
        "People, Place, Process, and Technology",
        "Finance and Purchase only",
        "Production and Dispatch",
      ],
      // correctAnswer: "People, Place, Process, and Technology",
    },
    {
      question:
        "Which of the following is an example of Facility Management service?",
      options: [
        "Payroll processing",
        "Building maintenance, housekeeping, security, utilities",
        "Share trading",
        "Advertising campaign",
      ],
      // correctAnswer: "Building maintenance, housekeeping, security, utilities",
    },
    {
      question: "ISO 41001 requires facility services to be aligned with:",
      options: [
        "Employee personal opinions",
        "Organizational strategic objectives",
        "Vendor demands",
        "Social media feedback",
      ],
      // correctAnswer: "Organizational strategic objectives",
    },
    {
      question: "Which documented information is essential in ISO 41001?",
      options: [
        "Facility Management Policy and Objectives",
        "Employee birthday list",
        "Advertisement records",
        "Social media reports",
      ],
      // correctAnswer: "Facility Management Policy and Objectives",
    },
    {
      question: "Why is risk assessment important in ISO 41001?",
      options: [
        "To increase utility bills",
        "To identify facility-related risks and service disruptions",
        "To remove all suppliers",
        "To reduce staff leave",
      ],
      // correctAnswer: "To identify facility-related risks and service disruptions",
    },
    {
      question: "Monitoring maintenance schedules helps to:",
      options: [
        "Increase breakdowns",
        "Ensure reliable and uninterrupted facility services",
        "Avoid documentation",
        "Stop preventive actions",
      ],
      // correctAnswer: "Ensure reliable and uninterrupted facility services",
    },
    {
      question: "Effective ISO 41001 implementation helps improve:",
      options: [
        "Facility performance, safety, sustainability, and user satisfaction",
        "Only office decoration",
        "Only attendance",
        "Only employee salaries",
      ],
      // correctAnswer: "Facility performance, safety, sustainability, and user satisfaction",
    },
  ],

  "ISO-29001 module-1": [
    {
      question: "What is the primary purpose of ISO 29001?",
      options: [
        "Environmental protection",
        "Quality management for petroleum, petrochemical, and natural gas industries",
        "Financial management",
        "Occupational safety",
      ],
      // Answer: b
    },
    {
      question: " ISO 29001 is based on which international standard?",
      options: ["ISO 14001", "ISO 45001", "ISO 9001", "ISO 27001"],
      // Answer: c
    },
    {
      question: "Why was ISO 29001 developed?",
      options: [
        "To replace ISO 9001",
        "To address quality and risk requirements specific to the petroleum, petrochemical, and natural gas industries",
        "To manage environmental impacts only",
        "To improve financial performance",
      ],
      // Answer: b
    },
    {
      question: " What is a key objective of ISO 29001?",
      options: [
        "Reduce taxes",
        "Improve product and service quality while reducing risks",
        "Increase advertising",
        "Improve website traffic",
      ],
      // Answer: b
    },
    {
      question: "What does risk-based thinking mean ?",
      options: [
        "Ignoring risks",
        "Identifying and addressing risks proactively",
        "Transferring risks to customers",
        " Eliminating all risks",
      ],
      // Answer: b
    },
    {
      question: "Why is customer focus important?",
      options: [
        "To increase paperwork",
        "To meet customer requirements and enhance customer satisfaction",
        "To reduce training needs",
        "To avoid audits",
      ],
      // Answer: b
    },
    {
      question: "What is a nonconformity?",
      options: [
        "A customer complaint only",
        "Failure to meet a specified requirement",
        " An internal meeting",
        " A training record",
      ],
      // Answer: b
    },
    {
      question:
        " Who is responsible for the effectiveness of the management system?",
      options: [
        "Top management only",
        "Quality department only",
        "All employees and management",
        " External auditors",
      ],
      // Answer: c
    },
    {
      question: " Why are documented procedures important?",
      options: [
        "To create more paperwork",
        "To ensure consistency, control, and effective operations",
        "To replace employee training",
        "To satisfy suppliers only",
      ],
      // Answer: b
    },
    {
      question: " What does continual improvement mean?",
      options: [
        "Ongoing enhancement of the management system and its performance",
        "Making changes daily",
        "Increasing workload",
        "Revising documents only",
      ],
      // Answer: a
    },
  ],
  "ISO-10002 module-1": [
    {
      question: "What is the primary objective of ISO 10002?",
      options: [
        "Customer complaints handling",
        "Environmental management",
        "Information security",
        "Occupational safety",
      ],
      // Answer: a
    },
    {
      question: "ISO 10002 provides guidelines for handling:",
      options: [
        "Employee grievances",
        "Supplier audits",
        "Customer complaints",
        "Financial risks",
      ],
      // Answer: c
    },
    {
      question:
        "Which principle ensures the complaints process is easy for customers to use?",
      options: [
        "Accessibility",
        "Countability",
        "Confidentiality",
        "Competence",
      ],
      // Answer: a
    },
    {
      question:
        "Who is responsible for demonstrating leadership and commitment to the complaints-handling process?",
      options: ["Top Management", "Internal Audit", "Customer", "Suppliers"],
      // Answer: a
    },
    {
      question:
        "Which clause of ISO 10002 focuses on the operation of the complaints-handling process?",
      options: ["Clause 5", "Clause 7", "Clause 6", "Clause 8"],
      // Answer: b
    },
    {
      question: "What should happen immediately after a complaint is received?",
      options: [
        "Acknowledge the complaint",
        "Close the complaint",
        "Ignore it",
        "Escalate to management",
      ],
      // Answer: a
    },
    {
      question: "What should every complaint receive when it is recorded?",
      options: [
        "Unique identifier",
        "Employee ID",
        "Invoice number",
        "Purchase order",
      ],
      // Answer: a
    },
    {
      question:
        "Which activity helps verify that the complaints-handling process is effective?",
      options: [
        "Marketing campaign",
        "Product advertising",
        "Internal audit",
        "Sales promotion",
      ],
      // Answer: c
    },
    {
      question: "Who should review the complaints-handling process regularly?",
      options: [
        "Top Management",
        "External suppliers",
        "IT Depart",
        "Finance department",
      ],
      // Answer: a
    },
    {
      question:
        "What is the ultimate goal of continually improving the complaints-handling process?",
      options: [
        "Reduce documentation",
        "Increase customer satisfaction and improve products and services",
        "Increase prices",
        "Reduce customer feedback",
      ],
      // Answer: b
    },
  ],
  "ISO-42001:2023 module-1": [
    {
      question: "What is ISO/IEC 42001:2023 primarily concerned with?",
      options: [
        "Quality Management",
        "Artificial Intelligence Management System (AIMS)",
        "Information Security",
        "Environmental Management",
      ],
      // Answer: b
    },
    {
      question: "What does AIMS stand for?",
      options: [
        "Artificial Intelligence Management System",
        "Automated Information Management System",
        "Artificial Information Monitoring Standard",
        "Advanced Intelligence Management System",
      ],
      // Answer: a
    },
    {
      question: "ISO/IEC 42001:2023 provides requirements for managing:",
      options: [
        "Only cybersecurity risks",
        "AI-related risks and opportunities",
        "Only financial risks",
        "Only employee performance",
      ],
      // Answer: b
    },
    {
      question:
        "Which organization is primarily responsible for establishing the AI policy?",
      options: [
        "Top management",
        "Customers",
        "External auditors",
        "Suppliers",
      ],
      // Answer: a
    },
    {
      question:
        "Which of the following is an important AI governance principle?",
      options: [
        "Transparency",
        "Advertising",
        "Sales growth",
        "Cost reduction only",
      ],
      // Answer: a
    },
    {
      question: "ISO/IEC 42001 follows which management system approach?",
      options: ["PDCA", "DMAIC only", "SWOT only", "Six Sigma only"],
      // Answer: a
    },
    {
      question: "Why is AI risk management important?",
      options: [
        "To identify and address potential AI-related impacts",
        "To increase marketing activities",
        "To eliminate documentation",
        "To avoid management involvement",
      ],
      // Answer: a
    },
    {
      question: "Which of the following may be an AI-related concern?",
      options: ["Bias", "Transparency", "Privacy", "All of the above"],
      // Answer: d
    },
    {
      question: "What is the role of employees in an AIMS?",
      options: [
        "Only management is responsible",
        "Employees should understand their relevant AI responsibilities",
        "Employees have no role",
        "Only external auditors are responsible",
      ],
      // Answer: b
    },
    {
      question: "What is the ultimate objective of an AIMS?",
      options: [
        "Responsible and effective management of AI systems",
        "Elimination of AI systems",
        "Increasing sales only",
        "Reducing employee involvement",
      ],
      // Answer: a
    },
  ],
  "ISO 22716:2007 module-1": [
    {
      question: "What is the primary purpose of ISO 22716:2007?",
      options: [
        "To establish environmental management requirements for cosmetic manufacturers",
        "To provide guidelines for Good Manufacturing Practices in cosmetic products",
        "To establish requirements for medical device manufacturing",
        "To define requirements for financial management systems",
      ],
      // Answer: b
    },
    {
      question:
        "Why should access to cosmetic manufacturing areas be controlled?",
      options: [
        "To reduce the need for documentation",
        "To prevent authorized employees from entering production areas",
        "To eliminate the need for equipment maintenance",
        "To minimize contamination risks and unauthorized access",
      ],
      // Answer: d
    },
    {
      question:
        "What should be considered when selecting equipment for cosmetic manufacturing?",
      options: [
        "Its appearance and purchase price only",
        "Its suitability for the intended operation and its ability to be cleaned and maintained",
        "Whether it can be operated without written instructions",
        "Whether it eliminates the need for quality control",
      ],
      // Answer: b
    },
    {
      question:
        "What should an organization do when receiving raw materials and packaging materials?",
      options: [
        "Use the materials immediately without checking them",
        "Store all materials together without identification",
        "Check the materials against relevant requirements and establish their status",
        "Release all materials based only on the supplier's invoice",
      ],
      // Answer: c
    },
    {
      question: "When should a finished cosmetic product be released?",
      options: [
        "Immediately after packaging, without review",
        "When the production operator requests release",
        "After the required checks have been completed and the product has been appropriately authorized for release",
        "Before quality control activities are completed",
      ],
      // Answer: c
    },
    {
      question:
        "How should a product that does not meet its specified requirements be handled?",
      options: [
        "It should be released if production is behind schedule",
        "It should be identified and controlled to prevent unintended use or release",
        "It should be mixed with an approved product without evaluation",
        "It should be distributed before the investigation is completed",
      ],
      // Answer: b
    },
    {
      question:
        "Why is proper waste management important in cosmetic manufacturing?",
      options: [
        "It allows waste to accumulate in production areas",
        "It helps prevent contamination and maintains hygienic conditions",
        "It eliminates the need for cleaning procedures",
        "It permits all waste types to be handled identically",
      ],
      // Answer: b
    },
    {
      question:
        "What should be done when a deviation from an approved procedure occurs?",
      options: [
        "Ignore it if the product appears normal",
        "Modify the records to show that the procedure was followed",
        "Automatically release the affected product",
        "Record and evaluate the deviation, including its potential impact on product quality",
      ],
      // Answer: d
    },
    {
      question:
        "What is the purpose of an internal audit under ISO 22716:2007?",
      options: [
        "To identify whether GMP practices and established procedures are being followed",
        "To replace all quality control testing",
        "To guarantee that no future complaints will occur",
        "To eliminate the need for corrective actions",
      ],
      // Answer: a
    },
    {
      question: "Why is documentation important under ISO 22716:2007?",
      options: [
        "It allows procedures to be changed without review",
        "It removes the need for employee training",
        "It provides instructions and records that support the control and traceability of GMP activities",
        "It ensures that every manufacturing activity can be performed without authorization",
      ],
      // Answer: c
    },
  ],
};
